import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimeAgoModule } from '../../../../../date-time/src/lib/time-ago/time-ago.module';
import { TimeAgoCellRendererComponent } from './time-ago-cell-renderer.component';

@NgModule({
  declarations: [TimeAgoCellRendererComponent],
  imports: [CommonModule, TimeAgoModule],
  exports: [TimeAgoCellRendererComponent],
})
export class TimeAgoCellRendererModule {}
